import * as actionTypes from './actiontypes';
import getAdminInitialState from './states';
import { LOCAL_STORAGE } from '../../config/constants';

const admin_details = (state = getAdminInitialState().admin_details, action) => {
  switch (action.type) {
    case actionTypes.AUTH_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          auth_loading: true,
        }
      };

    case actionTypes.AUTH_LOADED:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          auth_loading: false,
        }
      };

    case actionTypes.LOGIN_SUCCESS: {
      const oriAdminDetails = {
        nlpServiceDetails: action.payload.nlpServiceDetails,
        allowedChannels: action.payload.allowedChannelsDetails ? action.payload.allowedChannelsDetails : [],
        brandInfo: action.payload.brandInfo,
        admin_id: action.payload.adminId,
        token: action.payload.token,
        user_info: action.payload.user,
        _id: action.payload._id,
      };
      localStorage.setItem(LOCAL_STORAGE.ORI_ADMIN, JSON.stringify(oriAdminDetails));

      return {
        ...state,
        ...oriAdminDetails,
        loaders: {
          ...state.loaders,
          auth_loading: false,
        }
      };
    }

    case actionTypes.TOKEN_VERIFYING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          token_verifying: true,
          token_verified: false,
        }
      };

    case actionTypes.TOKEN_VERIFIED:
      return {
        ...state,
        user_info: action.payload.user ? action.payload.user[0] : [...state.user_info],
        loaders: {
          ...state.loaders,
          token_verifying: false,
          token_verified: true
        }
      };

    case actionTypes.TOKEN_VERIFICATION_FAILED:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          token_verifying: false,
          token_verified: false
        }
      };

    case actionTypes.UPDATE_USER_INFO: {
      const oriAdminDetails = {
        nlpServiceDetails: state.nlpServiceDetails,
        admin_id: state.admin_id,
        token: state.token,
        allowedChannels: state.allowedChannels,
        brandInfo: state.brandInfo,
        user_info: {
          ...state.user_info,
          ...action.payload
        },
        _id: state._id,
      };
      localStorage.setItem(LOCAL_STORAGE.ORI_ADMIN, JSON.stringify(oriAdminDetails));
      return {
        ...state,
        user_info: {
          ...state.user_info,
          ...action.payload
        },
      };
    }

    case actionTypes.AGENT_STATE_UPDATED: {
      return {
        ...state,
        current_state: action.payload,
      };
    }

    default:
      return state;
  }
}

export default admin_details;



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/reducers.js